import React, { Component, Fragment } from 'react';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { AppConfig } from '../../AppConfig';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { Controller } from '../../common/Controller';

import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';

export class Orders extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = 'Orders'
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['orders'], { state: 'INIT' }) },
    ]
    this.noAdd = true
    this.tableHeadersMap = {
      'Order ID / Time': (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.id}</span>
            <br/>
            <span className={css(Styles.spanValue)}>{Helper.formatTimestamp(current.createdTs)}</span>
          </div>
        )
      },
      Product: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.orderType}</span>
            <br/>
            <span className={css(Styles.spanValue)}>{current.itemOneId !== 'CONTACT' ? current.items[0].id : ''}</span>
            <br/>
            {current.items.map((item, index) => {
              if (current.orderType !== 'CONTACT') {
                return (<span className={css(Styles.spanValue)}>{(item.quantity || '1') + ' (qty) of ' + item.title}</span>)
              }
            })}
          </div>
        )
      },
      Customer: (current) => {
        return (
          <div>
            {current.userInfo &&
              <Fragment>
                <span className={css(Styles.spanValue)}>{current.userInfo.name || ''}</span>
                <br />
                <span className={css(Styles.spanValue)}>{current.userInfo.phone || ''}</span>
                <br />
                <span className={css(Styles.spanValue)}>{current.userInfo.email || ''}</span>
                <br />
                <span className={css(Styles.spanValue)}>{current.userInfo.message || ''}</span>
              </Fragment>
            }
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDef;
    this.setState({
      items: results[0].items,
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onActions = (current) => {
    const actions = []
    if (current.itemOneId !== 'CONTACT') {
      actions.push(AppHelper.buttonOpenProduct(this, { id: current.itemOneId }))
    }
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/Orders.js